import { TThunkAction } from '../../../types/redux';
import { openCloudPaymentsWidgetThunk } from '../openCloudPaymentsWidget';
import { selectPaymentAmount, selectPaymentInitSource, selectTransactionId } from '../../../selectors/checkout';
import { getBaseCloudPaymentsWidgetParams } from '../../../services/cloudPayments/getBaseCloudPaymentsWidgetParams';
import { setWidgetError, setWidgetStatus, setWidgetVisibility } from '../../../actions/layout';
import { EWidgetStatus } from '../../../types/redux/layout';
import { selectIsModal } from '../../../selectors/layout';

export const payByCloudPaymentsThunk =
  (): TThunkAction =>
  async (dispatch, getState, { httpApi }) => {
    const state = getState();
    const transactionId = selectTransactionId(state);
    const amount = selectPaymentAmount(state);
    const paymentInitSource = selectPaymentInitSource(state);
    const isModal = selectIsModal(state);

    const { widgetOptions, paymentOptions } = await getBaseCloudPaymentsWidgetParams({
      httpApi,
      amount,
      paymentInitSource,
      transactionId,
    });

    dispatch(setWidgetStatus(EWidgetStatus.Ready));

    if (!paymentOptions) {
      dispatch(setWidgetError('Не удалось получить данные для оплаты. Попробуйте ещё раз.'));

      return;
    }

    if (isModal) {
      dispatch(setWidgetVisibility(false));
    }

    dispatch(openCloudPaymentsWidgetThunk({ widgetOptions, paymentOptions }));
  };
